import { render, staticRenderFns } from "./addElement.vue?vue&type=template&id=2d561ffa&scoped=true&"
import script from "./addElement.vue?vue&type=script&lang=js&"
export * from "./addElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d561ffa",
  null
  
)

export default component.exports